import { createContext, useContext, useState } from "react";

const DeviceDataContext = createContext();

export function DeviceSocketProvider({ children }) {
	const [deviceData, setDeviceData] = useState({});
	return <DeviceDataContext.Provider value={{ deviceData, setDeviceData }}>{children}</DeviceDataContext.Provider>;
}

export function useDeviceContext() {
	const context = useContext(DeviceDataContext);
	if (!context) {
		throw new Error("useDeviceContext must be within a DeviceSocketProvider");
	}
	return context;
}

const SocketContext = createContext();

export function SocketProvider({ children }) {
	const [socketData, setSocketData] = useState({
		checkpointEvents: [],
		tagData: {},
		assetScanData: [],
		approvalEvents: [],
	});

	const clearApprovalEvents = () => {
		setSocketData((prev) => ({
		...prev,
		approvalEvents: [],
		}));
  	};

	const value = { socketData, setSocketData, clearApprovalEvents };

	return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
}

export function useSocketContext() {
	const context = useContext(SocketContext);
	if (!context) {
		throw new Error("useSocketContext must be within a SocketProvider");
	}
	return context;
}
